(function () {
  "use strict";

  /* Menu mobile */
  var toggle = document.querySelector("[data-menu-toggle]");
  var mobileNav = document.querySelector("[data-mobile-nav]");
  if (toggle && mobileNav) {
    toggle.addEventListener("click", function () {
      var willOpen = mobileNav.hasAttribute("hidden");
      if (willOpen) {
        mobileNav.removeAttribute("hidden");
      } else {
        mobileNav.setAttribute("hidden", "");
      }
      toggle.setAttribute("aria-expanded", String(willOpen));
    });
  }

  /* Statut d'ouverture : lundi → samedi 11h–19h30, fermé dimanche (heure de Paris) */
  var status = document.querySelector("[data-open-status]");
  if (status) {
    var parts = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Europe/Paris",
      weekday: "short",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    }).formatToParts(new Date());
    var pick = function (type) {
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type === type) return parts[i].value;
      }
      return "";
    };
    var hour = parseInt(pick("hour"), 10);
    var minute = parseInt(pick("minute"), 10);
    var weekday = pick("weekday");
    var mins = hour * 60 + minute;
    var isSunday = weekday === "Sun";
    var isOpen = !isSunday && mins >= 660 && mins < 1170;
    var label;
    if (isOpen) label = "Ouvert jusqu'à 19h30";
    else if (!isSunday && mins < 660) label = "Ouverture aujourd'hui à 11h";
    else if (!isSunday && mins >= 1170) label = "Fermé, réouverture demain à 11h";
    else label = "Fermé le dimanche — réouverture lundi à 11h";

    var text = status.querySelector("[data-open-label]");
    if (text) text.textContent = label;
    var dot = status.querySelector(".ss-status__dot");
    if (dot && isOpen) dot.classList.add("ss-status__dot--open");
  }

  /* Galerie produit */
  var gallery = document.querySelector("[data-gallery]");
  if (gallery) {
    var main = gallery.querySelector("[data-gallery-main]");
    var thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
    Array.prototype.forEach.call(thumbs, function (thumb) {
      thumb.addEventListener("click", function () {
        if (main) main.src = thumb.getAttribute("data-src");
        Array.prototype.forEach.call(thumbs, function (t) {
          t.setAttribute("aria-current", "false");
        });
        thumb.setAttribute("aria-current", "true");
      });
    });
  }

  /* Quantité +/- */
  Array.prototype.forEach.call(document.querySelectorAll("[data-qty]"), function (wrap) {
    var input = wrap.querySelector("input");
    if (!input) return;
    Array.prototype.forEach.call(wrap.querySelectorAll("[data-qty-action]"), function (btn) {
      btn.addEventListener("click", function () {
        var step = btn.getAttribute("data-qty-action") === "plus" ? 1 : -1;
        var min = parseInt(input.getAttribute("min") || "0", 10);
        var next = parseInt(input.value || "1", 10) + step;
        if (next < min) next = min;
        input.value = next;
        var form = input.form || input.closest("form");
        if (form && form.hasAttribute("data-auto-submit")) form.submit();
      });
    });
  });

  /* Panier : mise à jour automatique au changement de quantité */
  Array.prototype.forEach.call(document.querySelectorAll("form[data-auto-submit] input[type='number']"), function (input) {
    input.addEventListener("change", function () {
      if (input.form) input.form.submit();
    });
  });
})();